export const EPIC_TRACKING_UUID = '_epicTrackingId';
export const EPIC_TRACKING_UUID_PARAM = 'epicTid';
